import React from "react";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import moment from "moment";
import {
  getGpsStatusColor,
  getLocationStatusColor,
  formatDistance,
} from "./TrackingUtils";
import { formatTime } from "./TrackingUtils";

const LocationLogs = ({
  locationLogsData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  locationLogsLoading,
}) => {
  const locationLogsColumns = [
    {
      dataField: "name",
      text: <p className="table__header">Employee</p>,
      formatter: (cell, row) => {
        return (
          <div className="employee-cell">
            <div className="employee-info">
              <p className="tb-data font-weight-bold">{row?.name || "-"}</p>
              <small className="tb-data text-muted">
                ID: {row?.user_id || "-"}
              </small>
              <small className="tb-data text-muted">{row?.mobile || ""}</small>
            </div>
            <span
              className="badge bg-info"
              style={{
                padding: "4px 8px",
                borderRadius: "12px",
                fontSize: "11px",
                fontWeight: "600",
              }}
            >
              {row?.account_type?.toUpperCase() || ""}
            </span>
          </div>
        );
      },
    },
    {
      dataField: "gym_name",
      text: <p className="table__header">Gym</p>,
      formatter: (cell, row) => {
        return (
          <div>
            <p className="tb-data">{row?.gym_name || "-"}</p>
          </div>
        );
      },
    },
    {
      dataField: "location_info",
      text: <p className="table__header">Location Info</p>,
      formatter: (cell, row) => {
        return (
          <div className="location-info-cell">
            <div style={{ marginBottom: "4px" }}>
              <span style={{ fontSize: "11px", color: "#666" }}>Lat:</span>
              <span style={{ marginLeft: "4px", fontSize: "12px" }}>
                {row?.user_lat ? parseFloat(row.user_lat).toFixed(6) : "-"}
              </span>
            </div>
            <div style={{ marginBottom: "4px" }}>
              <span style={{ fontSize: "11px", color: "#666" }}>Long:</span>
              <span style={{ marginLeft: "4px", fontSize: "12px" }}>
                {row?.user_long ? parseFloat(row.user_long).toFixed(6) : "-"}
              </span>
            </div>
            <div>
              <span style={{ fontSize: "11px", color: "#666" }}>Distance:</span>
              <span
                style={{
                  marginLeft: "4px",
                  fontSize: "12px",
                  fontWeight: "600",
                  color: row?.status === "out_of_range" ? "#dc3545" : "#28a745",
                }}
              >
                {formatDistance(row?.distance_m)}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "gps_status",
      text: <p className="table__header">GPS Status</p>,
      formatter: (cell, row) => {
        const gpsColors = getGpsStatusColor(row?.gps_status);
        const isEnabled = row?.gps_status === "1" || row?.gps_status === 1;
        return (
          <span
            className="tb-data status-badge"
            style={{
              background: gpsColors.bg,
              color: gpsColors.color,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
              textTransform: "uppercase",
            }}
          >
            {isEnabled ? "Enabled" : "Disabled"}
          </span>
        );
      },
    },
    {
      dataField: "status",
      text: <p className="table__header">Location Status</p>,
      formatter: (cell, row) => {
        const statusColors = getLocationStatusColor(row?.status);
        return (
          <span
            className="tb-data status-badge"
            style={{
              background: statusColors.bg,
              color: statusColors.color,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              fontWeight: "600",
              textTransform: "capitalize",
            }}
          >
            {row?.status?.replace("_", " ") || "Unknown"}
          </span>
        );
      },
    },
    {
      dataField: "date_time",
      text: <p className="table__header">Date & Time</p>,
      formatter: (cell, row) => {
        return (
          <div className="date-cell">
            <p className="tb-data table__Text">{row?.log_date || "-"}</p>
            <small className="time-display">
              {row?.time_stamp ? formatTime(row?.time_stamp) : "-"}
            </small>
          </div>
        );
      },
    },
  ];

  return (
    <div className="location-logs-container">
      {locationLogsLoading ? (
        <div style={{ padding: "40px", textAlign: "center" }}>
          <ReactVortoxSpinner />
        </div>
      ) : locationLogsData?.data?.length === 0 ? (
        <div
          className="no-data-found"
          style={{
            padding: "40px",
            textAlign: "center",
            color: "#666",
          }}
        >
          <p>No location logs found</p>
        </div>
      ) : (
        <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table location-tracking-table-container">
          <PaymentLinkTable
            tableColumns={locationLogsColumns}
            tableData={locationLogsData?.data || []}
            tablePagination={locationLogsData?.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            setPageLimit={setPageLimit}
            pageLimit={pageLimit}
            isFirstColSticky={true}
          />
        </div>
      )}
    </div>
  );
};

export default LocationLogs;
